import { warnLog } from '../../tools/log';
import XEUtils from 'xe-utils';
/**
 * 创建数据仓库
 */
var Store = /** @class */ (function () {
    function Store() {
        this.store = {};
    }
    Store.prototype.mixin = function (options) {
        var _this = this;
        XEUtils.each(options, function (item, key) {
            _this.add(key, item);
        });
        return this;
    };
    Store.prototype.has = function (name) {
        return !!this.get(name);
    };
    Store.prototype.get = function (name) {
        return this.store[name];
    };
    Store.prototype.add = function (name, render) {
        var conf = this.store[name];
        // 检测是否覆盖
        if (process.env.NODE_ENV === 'development') {
            var confKeys_1 = XEUtils.keys(conf);
            XEUtils.each(render, function (item, key) {
                if (confKeys_1.includes(key)) {
                    warnLog('vxe.error.coverProp', [name, key]);
                }
            });
        }
        this.store[name] = conf ? XEUtils.merge(conf, render) : render;
        return this;
    };
    Store.prototype.delete = function (name) {
        delete this.store[name];
    };
    Store.prototype.forEach = function (callback) {
        XEUtils.objectEach(this.store, callback);
    };
    return Store;
}());
export { Store };
export default Store;
